export const iconFontAwesomeMedicalHealthClipboardUser = (
	<i className="fa-solid fa-clipboard-user"></i>
);
